<template>
  <picture class="animation-number">
    <source
      media="(min-width: 1280px)"
      :srcset="`/img/${src}-${index}@dt.png`"
    />
    <source media="(min-width: 768px)" :srcset="`/img/${src}-${index}.png`" />
    <img :src="`/img/${src}-${index}.png`" alt="" />
  </picture>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    src: {
      type: String
    }
  },
  computed: {
    ...mapGetters('data', ['RESOURCES_URL'])
  }
}
</script>



// WEBPACK FOOTER //
// components/ShapeNumberItem.vue